'use strict';

function initNarvarEvents() {
	$('form[id="NarvarUpdateForm"]').on('submit', function (e) {
		e.preventDefault();
        if (!$(this).valid()) {
            return false;
        }

        var isApply = $('#dwfrm_narvar_narvarupdate').data('apply');
		var optIn = document.getElementById('dwfrm_narvar_narvarOptIn').checked;

		if (!isApply) {
			setFormState(optIn, true);
			setButtonState(true);
			return;
		}

		var data = $(this).serialize();
        var url = util.appendParamToURL($(this).attr('action'), 'format', 'ajax');

        $.ajax({
            type: 'POST',
            url: url,
            data: data
        }).done(function (data) {
        	if (data.valid) {
        		setFormState(data.optIn);
        		setButtonState(!data.optIn);
        		if (data.optIn) {
        			document.getElementById('dwfrm_narvar_narvarContact').value = data.redactedContact;
        			document.getElementById('dwfrm_narvar_narvarupdate').innerHTML = data.buttonText;
        		} else {
        			document.getElementById('dwfrm_narvar_narvarContact').value = '';
        			document.getElementById('dwfrm_narvar_narvarupdate').innerHTML = data.buttonText;
        		}
        	}
        	$('.narvar-response').html(data.response);
        });

	});
	$('#dwfrm_narvar_narvarOptIn').on('click', function (e) {
		var optIn = document.getElementById('dwfrm_narvar_narvarOptIn').checked;
		setFormState(optIn, true);
		setButtonState(true);
	});

    let curLanguage = $('.locale-select-link.is-current').attr('data-locale') === 'fr_CA' ? 'fr' : 'en';

    if ($('.narvar-track').length > 0) {
        window.narvar('track', {
            retailer: 'sportinglife',
            locale_language: curLanguage,
            locale_country: 'ca',
            tracking_numbers: $('.narvar-track').attr('data-tracking-numbers'),
            carrier: $('.narvar-track').attr('data-carrier'),
            order_number: $('.narvar-track').attr('data-order-number'),
            version_name: $('.narvar-track').attr('data-version-name')
        });
    }
}

function setFormState (optIn, clearContact) {
	$('.narvar-response').html('');
	if (optIn) {
		document.getElementById('dwfrm_narvar_narvarContact').required = true;
		document.getElementById('dwfrm_narvar_narvarContact').disabled = !clearContact;
		$('#dwfrm_narvar_narvarContact').addClass('required');
		if (clearContact) {
			document.getElementById('dwfrm_narvar_narvarContact').value = '';
		}

	} else {
		document.getElementById('dwfrm_narvar_narvarContact').required = false;
		document.getElementById('dwfrm_narvar_narvarContact').disabled = true;
		document.getElementById('dwfrm_narvar_narvarContact').value = '';
		$('#dwfrm_narvar_narvarContact').removeClass('required');
		$('#dwfrm_narvar_narvarContact').valid();
	}
}

function setButtonState (apply) {
	$('#dwfrm_narvar_narvarupdate').data('apply', apply);
	if (apply) {
		document.getElementById('dwfrm_narvar_narvarupdate').innerHTML = Resources.GLOBAL_APPLY;
	}
}

var narvar = {
    init: function () {
    	initNarvarEvents();
        let optinInput = document.getElementById('dwfrm_narvar_narvarOptIn');
        if (optinInput) {
        	setFormState(optinInput.checked);
        }
    }
};

module.exports = narvar;
